import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const paddle = defineConnector({
  identifier: "paddle",
  name: "Paddle",
  tagLine: "Payments for SaaS",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://(api|sandbox-api)\\.paddle\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Select your environment",
      items: [
        {
          kind: "select",
          label: "Environment",
          required: true,
          target: { kind: "configuration", field: "environment" },
          options: [
            { value: "api.paddle.com", label: "Production" },
            { value: "sandbox-api.paddle.com", label: "Sandbox" },
          ],
          defaultValue: "api.paddle.com",
          helperText:
            "Select whether to use production or sandbox credentials.",
        },
      ],
    },
    {
      title: "Get your Paddle API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Paddle dashboard, go to **Developer Tools > Authentication** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ environment }) => `https://${environment}/products`,
  },
});
